import { useNavigation } from '@app/hooks/useNavigation';
import { useEffect } from 'react';
import { Layout } from '../Layout/Layout';

export function Documents() {
  const { navigation, setNavigation } = useNavigation();

  useEffect(() => {
    if (navigation.scope !== 'dashboardv2') {
      setNavigation((nav) => void (nav.scope = 'dashboardv2'));
    }
  }, [navigation]);

  return (
    <Layout title="Documents">
      <p>This is the Documents section where users can view and manage their documents.</p>
    </Layout>
  );
}
